var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4464 10.52C16.5863 10.386 16.6667 10.1985 16.6667 10.0021C16.6667 9.80569 16.5863 9.62117 16.4464 9.48426L11.2083 4.48426C10.9226 4.21045 10.4702 4.22236 10.1994 4.50807C9.92857 4.79379 9.9375 5.24617 10.2232 5.517L14.1696 9.28784H4.04762C3.65179 9.28784 3.33334 9.60629 3.33334 10.0021C3.33334 10.398 3.65179 10.7164 4.04762 10.7164H14.1696L10.2202 14.4843C9.93453 14.7581 9.9256 15.2075 10.1964 15.4932C10.4673 15.7789 10.9196 15.7878 11.2054 15.517L16.4435 10.517L16.4464 10.52Z",
    fill: "#2E3285"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.67996a2592f54315fcd3b4bc1749e63c.svg";
export { ForwardRef as ReactComponent };